import React from 'react';

const MoviesHeroSection = () => {
  return (
    <section aria-labelledby="movies-hero-title" className="site-bg-hero text-center py-16 px-6">
      <p className="text-sm font-semibold uppercase tracking-[0.3em] text-blue-600">
        Cinema pessoal
      </p>
      <h1
        id="movies-hero-title"
        className="mt-4 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl"
      >
        Filmes
      </h1>
      <p className="mt-6 text-lg leading-8 text-gray-600 max-w-3xl mx-auto">
        Um MVP para organizar filmes que gosto, ja assisti ou ainda quero assistir, mantendo o mesmo
        estilo limpo da area de Laboratorio.
      </p>
    </section>
  );
};

export default MoviesHeroSection;
